import getQueryParam from '../formats/getQueryParam';
/**
 * Determine whether if mocked data is being used
 * Should be used where axios call is made
 * @param appEnvironment - APP_ENV config file variable
 */
const isMockData = (appEnvironment) => {
    var _a, _b;
    const isAllowedEnv = ['local', 'development'].includes(appEnvironment);
    if (!isAllowedEnv) {
        return false;
    }
    const hasQueryParam = ((_a = getQueryParam('mockData')) === null || _a === void 0 ? void 0 : _a.toUpperCase()) === 'TRUE';
    const hasSessionMockData = ((_b = sessionStorage.getItem('mockData')) === null || _b === void 0 ? void 0 : _b.toUpperCase()) === 'TRUE';
    return hasQueryParam || hasSessionMockData;
};
export default isMockData;
